module.exports = {
  COB: 'cob',
  COBV: 'cobv'
};
